import { render, staticRenderFns } from "./EventConfig.vue?vue&type=template&id=49d3e6e6&scoped=true"
import script from "./EventConfig.vue?vue&type=script&lang=js"
export * from "./EventConfig.vue?vue&type=script&lang=js"
import style0 from "./EventConfig.vue?vue&type=style&index=0&id=49d3e6e6&prod&lang=scss"
import style1 from "./EventConfig.vue?vue&type=style&index=1&id=49d3e6e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d3e6e6",
  null
  
)

export default component.exports